import React, { useState, useEffect } from 'react';
import { BASE_URL } from './Constants';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';

const AreaWisePayment = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState('');
  const [paymentData, setPaymentData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const token = localStorage.getItem('authToken');

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  };

  const fetchAreas = async () => {
    try {
      const res = await fetch(`${BASE_URL}get_areas`, { headers });
      const data = await res.json();
      if (data.status) {
        setAreas(data.data);
      }
    } catch (err) {
      console.error('Error fetching areas:', err);
    }
  };

 const fetchPaymentData = async () => {
  setLoading(true);

  try {
    let url = `${BASE_URL}area_wise_payment_report`;

    const params = [];
    if (fromDate) params.push(`from_date=${fromDate}`);
    if (toDate) params.push(`to_date=${toDate}`);
    if (selectedArea) params.push(`area=${selectedArea}`);

    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }

    const res = await fetch(url, { headers });
    const data = await res.json();

    if (data.status) {
      setPaymentData(data.data);
    } else {
      setPaymentData([]);
    }
  } catch (err) {
    console.error("Error fetching payment data:", err);
    setPaymentData([]);
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchPaymentData ();
    fetchAreas ();
  }, [fromDate, toDate, selectedArea]);

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  return (
    <div className="page-wrapper">
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{ marginLeft: isSidebarOpen ? '300px' : '100px' }}>
        <Header onToggleSidebar={handleToggleSidebar} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <h4 className="mb-4">Area Wise Payment Report</h4>

              <div className="row mb-3">
                <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <input
                    type="date"
                    className="form-control"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                  />
                </div>
                <div className="col-md-3">
                  <select
                    className="form-control"
                    value={selectedArea}
                    onChange={(e) => setSelectedArea(e.target.value)}
                  >
                    <option value="">Select Area</option>
                    {areas.map((area) => (
                      <option key={area.id} value={area.id}>
                        {area.area}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="col-md-3">
                  <button className="btn btn-primary" onClick={fetchPaymentData}>
                    Get Report
                  </button>
                </div> */}
              </div>

              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Area Name</th>
                      <th>Total Cost</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paymentData.length > 0 ? (
                      paymentData.map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item.area_name}</td>
                          <td>{item.total_cost}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">No data found.</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {loading && <div className="mt-3 text-center">Loading...</div>}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AreaWisePayment;
